<script>
	/*
		TCareReferralMyselfInfoFields.svelte

		Renders a block of user input fields.
		Returned value will be all the field values.

		This is a smaller version of TCareReferralContactInfoFields

		KEEP ALL STYLING LOCAL TO THIS FILE!

	*/

    import TCareFieldPair from "./TCareFieldPair.svelte";

	export let source;
	export let setValue;
	
</script>

<style>

.user-info-fields {
		width: 100%;
		margin: 20px 0px;
		/* border: 1px solid purple; */
	}

	.user-info-fields .spacer {
		width: 10%;
	}

	.user-info-fields .your-info {
		margin-bottom: 15px;
	    margin-left: 10px;
		font-size: 14px;
		line-height: 16px;
		color: #887392;
	}

</style>

<!-- this is a block of user input fields -->

<div class="tcui-control user-info-fields">
	<div class="flex-row">
		<div class="your-info">YOUR INFORMATION</div>
	</div>
	<div class="flex-row">
		<TCareFieldPair source={source['firstName']} prop={'value'} {setValue} 
			label={source['firstName'].label} isRequired={source['firstName'].isRequired}
		/>
		<div class="spacer"></div>
		<TCareFieldPair source={source['phoneNumber']} prop={'value'} {setValue} 
			label={'Phone Number'} isRequired={source['phoneNumber'].isRequired}
		/>
	</div>
	<div class="flex-row">
		<TCareFieldPair source={source['lastName']} prop={'value'} {setValue} 
			label={source['lastName'].label} isRequired={source['lastName'].isRequired}
		/>
		<div class="spacer"></div>
		<TCareFieldPair source={source['email']} prop={'value'} {setValue} 
			label={'Email'} isRequired={source['email'].isRequired}
		/>
	</div>
</div>

